import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import baseUrl from "../../../api/baseUrl";
import DeleteDialog from "../../components/modal/delete/DeleteDialog";  
import InputText from "../../../components/inputs/InputText";
import DropInput from "../../../components/inputs/DropInput";
import RadioInput from "../../../components/inputs/RadioInput";
import ImputImage from "../../../components/inputs/ImputImage";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../redux/loader/loaderActions";
import { useDispatch } from "react-redux";
import PhoneInput from "react-phone-number-input";
import { Socket, connect } from "socket.io-client";
import socketauth from "../../../api/socket";
import { patienttitles } from "../../../utils/title";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PersonIcon from "@mui/icons-material/Person";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import SaveIcon from "@mui/icons-material/Save";

const socket: Socket = connect(`${process.env.REACT_APP_WS}`, socketauth);

function FullregisterPatient() {
  const [isDisable, setDisable] = useState(false);
  const [erors, seterors] = useState(false);
  const dispatch = useDispatch();
  const { ID } = useParams();
  const navigate = useNavigate();

  const hanldeChangeDisable = () => {
    if (isDisable) {
      toast("You can now Edit");
      setDisable(!isDisable);
    } else {
      setDisable(!isDisable);
    }
  };

  const [formData, setformData] = useState({
    registerdDate: "",
    fullName: "",
    gender: "",
    maritalStatus: "",
    dob: "",
    religion: "",
    whatsapp: "",
    smobileNo: "",
    otherNo: "",
    occupation: "",
    bloodGroup: "",
    image: null as string | ArrayBuffer | null,
    images: "",
    nic: "",
    title: "",
    email: "",
    mobileNo: "",
    telNo: "",
    address: "",
    nameOfIntroduce: "",
    vaccinated: "",
    patientType: "",
    allergies: { status: "false", note: "" },
    gastricProblem: { status: "false", note: "" },
    highBP: { status: "false", note: "" },
    diabetes: { status: "false", note: "" },
    monthlyInjection: { status: "false", note: "" },
    pregnancyBreastFeeding: { status: "false", note: "" },
    coughColdFever: { status: "false", note: "" },
    chestpainHeartProblem: { status: "false", note: "" },
    epilepsy: { status: "false", note: "" },
    previousExtraction: { status: "false", note: "" },
    previoussurgeries: { status: "false", note: "" },
    covid193Doses: { status: "false", note: "" },
    drugHistory: { status: "false", note: "" },
    dietaryHistory: { status: "false", note: "" },
    brushingHistory: { status: "false", note: "" },
    extraOralExamination: "",
    intraOralExamination: "",
    medicalHistoryNote: { status: "false", note: "" },
    oralHygieneHistory: { status: "false", note: "" },
    habitHistory: { status: "false", note: "" },
    familyHistory: { status: "false", note: "" },
    socialHistory: { status: "false", note: "" },
  });

  const [selectNavigate, setSelectNavigate] = useState<any>(0);
  const [active, setactive] = useState(false);

  const handleSelectNavugate = (i: any) => {
    if (i === 1) {
      if (
        formData.title === "" &&
        formData.fullName === "" &&
        formData.gender === "" &&
        formData.mobileNo === ""
      ) {
        seterors(true);
      } else {
        seterors(false);
        setSelectNavigate(i);
      }
    } else {
      setSelectNavigate(i);
    }
  };

  const onsubmit = (e: any) => {
    e.preventDefault();
    if (ID) {
      dispatch(setloadeActive());
      baseUrl
        .put("patient/update", formData, { headers: { patientid: ID } })
        .then((response) => {
          if (response.data.success) {
            dispatch(setloadeDeactive());
            toast.success("Patient Updated Successfully");
            navigate("/client/patients/patients-list/active");
          }
        })
        .catch((error) => {
          dispatch(setloadeDeactive());
          console.log(error);
        });
    } else {
      dispatch(setloadeActive());
      baseUrl
        .post("patient/full-register", formData)
        .then((response) => {
          if (response.data.success) {
            dispatch(setloadeDeactive());
            navigate("/client/patients/patients-list/active");
            toast.success("Patient Registered Successfully");
            socket.emit("addpatients", response.data.data);
          }
        })
        .catch((error) => {
          dispatch(setloadeDeactive());
          console.log(error);
        });
    }
  };

  useEffect(() => {
    if (ID) {
      dispatch(setloadeActive());
      setDisable(true);
      baseUrl
        .get("patient/findById", { headers: { patientid: ID } })
        .then((response) => {
          const item = response.data.data;
          dispatch(setloadeDeactive());
          if (ID) {
            setactive(item?.status);
            console.log(item?.gender);
            
            setformData({
              registerdDate: item?.registerdDate?.split("T")[0],
              fullName: item?.fullName,
              gender: item?.gender,
              dob: item?.dob?.split("T")[0],
              religion: item?.religion,
              whatsapp: item?.whatsapp,
              smobileNo: item?.smobileNo,
              maritalStatus: item?.maritalStatus,
              otherNo: item?.otherNo,
              occupation: item?.occupation,
              bloodGroup: item?.bloodGroup,
              image: null as string | ArrayBuffer | null,
              images: item?.image,
              nic: item?.nic,
              title: item?.title,
              email: item?.email,
              mobileNo: item?.mobileNo,
              telNo: item?.telNo,
              address: item?.address,
              nameOfIntroduce: item?.nameOfIntroduce,
              vaccinated: item?.vaccinated,
              patientType: item?.patientType,
              allergies: item?.allergies,
              gastricProblem: item?.gastricProblem,
              highBP: item?.highBP,
              diabetes: item?.diabetes,
              monthlyInjection: item?.monthlyInjection,
              pregnancyBreastFeeding: item?.pregnancyBreastFeeding,
              coughColdFever: item?.coughColdFever,
              chestpainHeartProblem: item?.chestpainHeartProblem,
              epilepsy: item?.epilepsy,
              previousExtraction: item?.previousExtraction,
              previoussurgeries: item?.previoussurgeries,
              covid193Doses: item?.covid193Doses,
              drugHistory: item?.drugHistory,
              dietaryHistory: item?.dietaryHistory,
              brushingHistory: item?.brushingHistory,
              extraOralExamination: item?.extraOralExamination,
              intraOralExamination: item?.intraOralExamination,
              medicalHistoryNote: typeof item?.medicalHistoryNote === "object" && item?.medicalHistoryNote !== null
                ? { status: String((item.medicalHistoryNote as any)?.status ?? "false"), note: (item.medicalHistoryNote as any)?.note ?? "" }
                : { status: "false", note: "" },
              oralHygieneHistory: typeof item?.oralHygieneHistory === "object" && item?.oralHygieneHistory !== null
                ? { status: String((item.oralHygieneHistory as any)?.status ?? "false"), note: (item.oralHygieneHistory as any)?.note ?? "" }
                : { status: "false", note: "" },
              habitHistory: typeof item?.habitHistory === "object" && item?.habitHistory !== null
                ? { status: String((item.habitHistory as any)?.status ?? "false"), note: (item.habitHistory as any)?.note ?? "" }
                : { status: "false", note: "" },
              familyHistory: typeof item?.familyHistory === "object" && item?.familyHistory !== null
                ? { status: String((item.familyHistory as any)?.status ?? "false"), note: (item.familyHistory as any)?.note ?? "" }
                : { status: "false", note: "" },
              socialHistory: typeof item?.socialHistory === "object" && item?.socialHistory !== null
                ? { status: String((item.socialHistory as any)?.status ?? "false"), note: (item.socialHistory as any)?.note ?? "" }
                : { status: "false", note: "" },
            });
          }
        })
        .catch((error) => {
          dispatch(setloadeDeactive());
          console.log(error);
        });
    }
  }, [ID, dispatch]);

  const handleChange = async (e: any) => {
    const { name, value, type } = e.target;
    if (type === "radio") {
      setformData({
        ...formData,
        [name]: { note: e.target.note, status: e.target.status },
      });
    } else if (type === "file") {
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.readyState === 2) {
            setformData({
              ...formData,
              image: reader.result as string,
              [name]: e.target.files[0],
            });
          }
        };
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      setformData({ ...formData, [name]: value });
    }
  };

  const [deleteOpen, setdeleteOpen] = useState(false);

  const onDelete = () => {
    setdeleteOpen(true);
  };

  const confirmDelete = () => {
    if (ID) {
      baseUrl
        .delete("patient/delete", { headers: { patientid: ID } })
        .then((response) => {
          setdeleteOpen(false);
          navigate("/client/patients/patients-list/active");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const activePatient = () => {
    if (ID) {
      baseUrl
        .delete("patient/active", { headers: { patientid: ID } })
        .then((response) => {
          setdeleteOpen(false);
          navigate("/client/patients/patients-list/active");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handlePhonenumber = (e: any) => {
    setformData({ ...formData, [e.name]: e.value });
  };

  return (
    <div className="">
      <style>{`
        .form__field {
          height: 32px !important;
          padding: 0px 12px !important;
          font-size: 12px !important;
        }
        .form__label {
          font-size: 12px !important;
        }
      `}</style>
      {deleteOpen && (
        <DeleteDialog
          onDelete={() => confirmDelete()}
          onCancel={() => setdeleteOpen(false)}
        />
      )}

      {/* Navigation Tabs & Actions */}
      <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 p-3">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          {/* Tab Buttons */}
          <div className="flex gap-2">
            <button
              onClick={() => handleSelectNavugate(0)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-lg font-medium text-xs transition-all ${
                selectNavigate === 0
                  ? "bg-gradient-to-r from-primary to-primaryLight text-white shadow-lg shadow-primary/30"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              <PersonIcon sx={{ fontSize: 16 }} />
              General Details
            </button>
            <button
              onClick={() => handleSelectNavugate(1)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-lg font-medium text-xs transition-all ${
                selectNavigate === 1
                  ? "bg-gradient-to-r from-primary to-primaryLight text-white shadow-lg shadow-primary/30"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              <MedicalServicesIcon sx={{ fontSize: 16 }} />
              Medical History
            </button>
          </div>

          {/* Action Buttons */}
          {ID && (
            <div className="flex gap-2">
              {active ? (
                <button
                  onClick={() => onDelete()}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 text-red-600 rounded-lg font-medium text-xs hover:bg-red-100 transition-colors"
                >
                  <DeleteIcon sx={{ fontSize: 16 }} />
                  Deactivate
                </button>
              ) : (
                <button
                  onClick={() => activePatient()}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-50 text-emerald-600 rounded-lg font-medium text-xs hover:bg-emerald-100 transition-colors"
                >
                  <CheckCircleIcon sx={{ fontSize: 16 }} />
                  Activate
                </button>
              )}
              <button
                onClick={hanldeChangeDisable}
                className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 text-amber-600 rounded-lg font-medium text-xs hover:bg-amber-100 transition-colors"
              >
                <EditIcon sx={{ fontSize: 16 }} />
                Edit
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Form */}
      <form onSubmit={onsubmit}>
        <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 p-4">
          {selectNavigate === 0 ? (
            /* General Details */
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {/* Left Column */}
              <div className="space-y-3">
                <InputText
                  isDisable={isDisable}
                  name="registerdDate"
                  type="date"
                  onChange={handleChange}
                  value={formData.registerdDate}
                  label="Registered Date"
                />

                {/* Full Name */}
                <div className="space-y-1.5">
                  <label className="text-xs font-medium text-slate-700">
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-2">
                    <select
                      disabled={isDisable}
                      name="title"
                      onChange={handleChange}
                      value={formData.title}
                      required={true}
                      className={`h-8 px-3 bg-slate-50 border rounded-lg outline-none transition-all text-xs text-slate-700 ${
                        erors && formData.title === ""
                          ? "border-red-500"
                          : "border-gray-600"
                      }`}
                    >
                      <option value="">Title</option>
                      {patienttitles.map((item: any, i: number) => (
                        <option key={i} value={item.value}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      disabled={isDisable}
                      name="fullName"
                      onChange={handleChange}
                      value={formData.fullName}
                      required={true}
                      className={`flex-1 h-8 px-3 bg-slate-50 border rounded-lg outline-none transition-all text-xs ${
                        erors && formData.fullName === ""
                          ? "border-red-500"
                          : "border-gray-600"
                      }`}
                    />
                  </div>
                  {erors &&
                    (formData.fullName === "" || formData.title === "") && (
                      <p className="text-xs text-red-500">
                        Full Name is mandatory
                      </p>
                    )}
                </div>

                <DropInput
                  isDisable={isDisable}
                  name="gender"
                  onChange={handleChange}
                  value={formData.gender}
                  label="Gender"
                  className="endDot"
                  required={true}
                  errors={formData.gender === "" && erors}
                  option={[
                    { name: "Male", value: "male" },
                    { name: "Female", value: "female" },
                    { name: "Other", value: "other" },
                  ]}
                />

                <InputText
                  isDisable={isDisable}
                  name="dob"
                  onChange={handleChange}
                  value={formData.dob}
                  label="Date Of Birth"
                  type="date"
                />

                <DropInput
                  isDisable={isDisable}
                  name="religion"
                  onChange={handleChange}
                  value={formData.religion}
                  label="Religion"
                  option={[
                    { name: "Christiant", value: "christiant" },
                    { name: "Buddhist", value: "buddhist" },
                    { name: "Muslims", value: "muslims" },
                    { name: "Hindu", value: "hindu" },
                  ]}
                />

                {/* WhatsApp */}
                <div className="space-y-1.5">
                  <label className="text-xs font-medium text-slate-700">
                    WhatsApp Number
                  </label>
                  <div className="[&_.PhoneInput]:bg-slate-50 [&_.PhoneInput]:border [&_.PhoneInput]:border-gray-600 [&_.PhoneInput]:rounded-lg [&_.PhoneInput]:px-3 [&_.PhoneInput]:py-0 [&_.PhoneInput]:text-sm [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:outline-none [&_.PhoneInputInput]:border-none [&_.PhoneInputInput]:text-sm">
                    <PhoneInput
                      disabled={isDisable}
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="LK"
                      value={formData.whatsapp}
                      onChange={(e) =>
                        handlePhonenumber({ value: e, name: "whatsapp" })
                      }
                    />
                  </div>
                </div>

                <InputText
                  isDisable={isDisable}
                  name="occupation"
                  onChange={handleChange}
                  value={formData.occupation}
                  label="Occupation"
                  type="text"
                />

                <DropInput
                  isDisable={isDisable}
                  name="maritalStatus"
                  onChange={handleChange}
                  value={formData.maritalStatus}
                  label="Marital Status"
                  option={[
                    { name: "Married", value: "Married" },
                    { name: "Single", value: "Single" },
                  ]}
                />

                <DropInput
                  isDisable={isDisable}
                  name="bloodGroup"
                  onChange={handleChange}
                  value={formData.bloodGroup}
                  label="Blood Group"
                  option={[
                    { name: "A+", value: "A+" },
                    { name: "O+", value: "O+" },
                    { name: "B+", value: "B+" },
                    { name: "AB+", value: "AB+" },
                    { name: "A-", value: "A-" },
                    { name: "O-", value: "O-" },
                    { name: "B-", value: "B-" },
                    { name: "AB-", value: "AB-" },
                  ]}
                />

                <ImputImage
                  isDisable={isDisable}
                  name="images"
                  onChange={handleChange}
                  value={formData.images}
                  imageback={formData.image}
                  label="Photo Attachment"
                  type="file"
                />

                <InputText
                  isDisable={isDisable}
                  name="nic"
                  onChange={handleChange}
                  value={formData.nic}
                  label="NIC Number"
                />
              </div>

              {/* Right Column */}
              <div className="space-y-3">
                <InputText
                  isDisable={isDisable}
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  label="Email Address"
                  type="email"
                />

                {/* Contact Number */}
                <div className="space-y-1.5">
                  <label className="text-xs font-medium text-slate-700">
                    Contact Number
                  </label>
                  <div className="[&_.PhoneInput]:bg-slate-50 [&_.PhoneInput]:border [&_.PhoneInput]:border-gray-600 [&_.PhoneInput]:rounded-lg [&_.PhoneInput]:px-3 [&_.PhoneInput]:py-0 [&_.PhoneInput]:text-sm [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:outline-none [&_.PhoneInputInput]:border-none [&_.PhoneInputInput]:text-sm">
                    <PhoneInput
                      disabled={isDisable}
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="LK"
                      value={formData.mobileNo}
                      onChange={(e) =>
                        handlePhonenumber({ value: e, name: "mobileNo" })
                      }
                    />
                  </div>
                </div>

                {/* Secondary Number */}
                <div className="space-y-1.5">
                  <label className="text-xs font-medium text-slate-700">
                    Secondary Number
                  </label>
                  <div className="[&_.PhoneInput]:bg-slate-50 [&_.PhoneInput]:border [&_.PhoneInput]:border-gray-600 [&_.PhoneInput]:rounded-lg [&_.PhoneInput]:px-3 [&_.PhoneInput]:py-0 [&_.PhoneInput]:text-sm [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:outline-none [&_.PhoneInputInput]:border-none [&_.PhoneInputInput]:text-sm">
                    <PhoneInput
                      disabled={isDisable}
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="LK"
                      value={formData.smobileNo}
                      onChange={(e) =>
                        handlePhonenumber({ value: e, name: "smobileNo" })
                      }
                    />
                  </div>
                </div>

                <InputText
                  isDisable={isDisable}
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  label="Address"
                />

                <DropInput
                  isDisable={isDisable}
                  name="nameOfIntroduce"
                  onChange={handleChange}
                  value={formData.nameOfIntroduce}
                  label="Mode Of Introduction"
                  option={[
                    { name: "From Friends", value: "friends" },
                    { name: "Facebook", value: "facebook" },
                    { name: "Other", value: "other" },
                  ]}
                />

                <DropInput
                  isDisable={isDisable}
                  name="patientType"
                  onChange={handleChange}
                  value={formData.patientType}
                  label="Patient Type"
                  option={[
                    { name: "VVIP", value: "VVIP" },
                    { name: "VIP", value: "VIP" },
                    { name: "Normal", value: "Normal" },
                  ]}
                />
              </div>
            </div>
          ) : (
            /* Medical History */
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {/* Left Column */}
              <div className="space-y-3">
                <RadioInput
                  value={formData.allergies}
                  isDisable={isDisable}
                  name="allergies"
                  onChange={handleChange}
                  label="Allergies"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="gastricProblem"
                  value={formData.gastricProblem}
                  onChange={handleChange}
                  label="Gastric Problem"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="highBP"
                  onChange={handleChange}
                  label="High Blood Pressure"
                  value={formData.highBP}
                />
                <RadioInput
                  isDisable={isDisable}
                  name="diabetes"
                  value={formData.diabetes}
                  onChange={handleChange}
                  label="Diabetes"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="monthlyInjection"
                  value={formData.monthlyInjection}
                  onChange={handleChange}
                  label="Monthly Injection (History of Rheumatic fever)"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="pregnancyBreastFeeding"
                  value={formData.pregnancyBreastFeeding}
                  onChange={handleChange}
                  label="Pregnancy / Breast Feeding"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="coughColdFever"
                  value={formData.coughColdFever}
                  onChange={handleChange}
                  label="Cough / Cold / Fever"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="chestpainHeartProblem"
                  value={formData.chestpainHeartProblem}
                  onChange={handleChange}
                  label="History Of (MI) Chest pain. High pressure & Heart Problem"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="epilepsy"
                  value={formData.epilepsy}
                  onChange={handleChange}
                  label="Epilepsy"
                />
              </div>

              {/* Right Column */}
              <div className="space-y-3">
                <RadioInput
                  isDisable={isDisable}
                  name="previousExtraction"
                  value={formData.previousExtraction}
                  onChange={handleChange}
                  label="Previous Extraction"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="previoussurgeries"
                  value={formData.previoussurgeries}
                  onChange={handleChange}
                  label="Previous Surgeries"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="covid193Doses"
                  value={formData.covid193Doses}
                  onChange={handleChange}
                  label="COVID19 (3 Doses)"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="drugHistory"
                  value={formData.drugHistory}
                  onChange={handleChange}
                  label="Drug History"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="dietaryHistory"
                  value={formData.dietaryHistory}
                  onChange={handleChange}
                  label="Dietary History"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="brushingHistory"
                  value={formData.brushingHistory}
                  onChange={handleChange}
                  label="Brushing History"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="medicalHistoryNote"
                  value={formData.medicalHistoryNote}
                  onChange={handleChange}
                  label="Medical history (note)"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="oralHygieneHistory"
                  value={formData.oralHygieneHistory}
                  onChange={handleChange}
                  label="Oral hygiene history"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="habitHistory"
                  value={formData.habitHistory}
                  onChange={handleChange}
                  label="Habit history"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="familyHistory"
                  value={formData.familyHistory}
                  onChange={handleChange}
                  label="Family history"
                />
                <RadioInput
                  isDisable={isDisable}
                  name="socialHistory"
                  value={formData.socialHistory}
                  onChange={handleChange}
                  label="Social history"
                />
                <InputText
                  isDisable={isDisable}
                  name="extraOralExamination"
                  value={formData.extraOralExamination}
                  onChange={handleChange}
                  label="Extra Oral Examination"
                />
                <InputText
                  isDisable={isDisable}
                  name="intraOralExamination"
                  value={formData.intraOralExamination}
                  onChange={handleChange}
                  label="Intra Oral Examination"
                />
              </div>
            </div>
          )}
        </div>

        {/* Form Actions */}
        <div className="flex justify-end gap-2 mt-3">
          {selectNavigate === 0 ? null : (
            <button
              type="button"
              onClick={() => handleSelectNavugate(0)}
              className="flex items-center gap-1.5 px-4 py-2 bg-slate-100 text-slate-600 rounded-lg font-medium text-xs hover:bg-slate-200 transition-colors"
            >
              <ArrowBackIcon sx={{ fontSize: 16 }} />
              Back
            </button>
          )}
          {selectNavigate === 0 ? (
              <div
                onClick={() => handleSelectNavugate(1)}
                className="flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg font-medium text-xs hover:shadow-lg hover:shadow-primary/30 transition-all"
              >
                Next
                <ArrowForwardIcon sx={{ fontSize: 16 }} />
              </div>
          ) : ID ? (
            !isDisable && (
              <button
                type="submit"
                className="flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg font-medium text-xs hover:shadow-lg hover:shadow-primary/30 transition-all"
              >
                <SaveIcon sx={{ fontSize: 16 }} />
                Update
              </button>
            )
          ) : (
            <button
              type="submit"
              className="flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg font-medium text-xs hover:shadow-lg hover:shadow-primary/30 transition-all"
            >
              <SaveIcon sx={{ fontSize: 16 }} />
              Register
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default FullregisterPatient;
